import { createFileRoute } from '@tanstack/react-router';
import { MarkdownPage } from '@/components/MarkdownPage';
import faq from '@/content/help/faq.md?raw';

// Help / FAQ page (/help).
// react-markdown + faq.md land in this route's lazy chunk via
// autoCodeSplitting: true — they are not pulled into the initial bundle.

export const Route = createFileRoute('/help')({
  component: HelpPage,
});

function HelpPage() {
  return (
    <MarkdownPage
      title="Help & FAQ"
      description="Frequently asked questions about booking, payment, check-in, and more."
      content={faq}
    />
  );
}
